import { useEffect } from 'react';
import { useFormik } from 'formik';
import { isEmpty } from 'lodash';
import {
  useNowEstablishPageTypeStore,
  useEstablishStore,
  getBtnProps,
  TransitionBtn,
  reloadHandler,
  useIsPrevPageConfirmStore,
} from 'views/components/pages/accountEstablishment/hooks';
import {
  EstablishPageType,
  AccountEstablishRequestParam,
  employmentInitialValues,
  EmploymentFormikType,
  employmentValidation,
  employmentOnSubmit,
  formErrorScroll,
  scrollToTop,
} from 'views/utils/accountEstablish';
import { ButtonProps } from 'views/components/atoms/button';
import { useNavigate } from 'react-router-dom';
import { EstablishCheckProps } from 'views/components/atoms/establishes/check';

export const useEmployment = () => {
  const navigate = useNavigate();
  const { nowEstablishPageType, setNowEstablishPageType } = useNowEstablishPageTypeStore();
  const { isPrevPageConfirm, setIsPrevPageConfirm } = useIsPrevPageConfirmStore();
  const { param, add } = useEstablishStore();
  const initialValues = employmentInitialValues(param);
  const onSubmit = employmentOnSubmit<AccountEstablishRequestParam>(param, add, () =>
    setNowEstablishPageType(isPrevPageConfirm ? EstablishPageType.RequestConfirm : EstablishPageType.InvestmentInfo),
  );

  const formik: EmploymentFormikType = useFormik({
    initialValues,
    validationSchema: employmentValidation,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit,
  });

  const nextButtonProps: ButtonProps = getBtnProps(TransitionBtn.NEXT);
  const prevButtonProps: ButtonProps = getBtnProps(TransitionBtn.PREV, () =>
    setNowEstablishPageType(EstablishPageType.DepositAccount),
  );
  const confirmButtonProps: ButtonProps = getBtnProps(TransitionBtn.CONFIRM);

  const isNoWorkplaceButtonProps: EstablishCheckProps = {
    name: 'isNoWorkplace',
    text: 'なし',
    isChecked: formik.values.isNoWorkplace,
    setIsChecked: () => {
      formik.setFieldValue('workplace', '');
      formik.setFieldValue('isNoWorkplace', !formik.values.isNoWorkplace);
    },
  };

  const isNoDepartmentButtonProps: EstablishCheckProps = {
    name: 'isNoDepartment',
    text: 'なし',
    isChecked: formik.values.isNoDepartment,
    setIsChecked: () => {
      formik.setFieldValue('department', '');
      formik.setFieldValue('isNoDepartment', !formik.values.isNoDepartment);
    },
  };

  const isNoPostButttonProps: EstablishCheckProps = {
    name: 'isNoPost',
    text: 'なし',
    isChecked: formik.values.isNoPost,
    setIsChecked: () => {
      formik.setFieldValue('post', '');
      formik.setFieldValue('isNoPost', !formik.values.isNoPost);
    },
  };

  const isNoWorkPhoneNumberButtonProps: EstablishCheckProps = {
    name: 'isNoWorkPhoneNumber',
    text: 'なし',
    isChecked: formik.values.isNoWorkPhoneNumber,
    setIsChecked: () => {
      formik.setFieldValue('workPhoneNumber', '');
      formik.setFieldValue('isNoWorkPhoneNumber', !formik.values.isNoWorkPhoneNumber);
    },
  };

  useEffect(() => {
    scrollToTop();
    window.addEventListener('beforeunload', reloadHandler);
    return () => {
      window.removeEventListener('beforeunload', reloadHandler);
    };
  }, []);

  useEffect(() => {
    if (nowEstablishPageType === EstablishPageType.CustomerInfo) return;
    navigate(nowEstablishPageType.toString());
  }, [nowEstablishPageType]);

  useEffect(() => {
    if (isEmpty(formik.errors)) return;
    formErrorScroll();
  }, [formik.isSubmitting]);

  return {
    formik,
    buttonProps: {
      nextButtonProps,
      prevButtonProps,
      confirmButtonProps,
      isPrevPageConfirm,
    },
    checkButtonProps: {
      isNoWorkplaceButtonProps,
      isNoDepartmentButtonProps,
      isNoPostButttonProps,
      isNoWorkPhoneNumberButtonProps,
    },
    isWorkPhoneNumberMask: false,
  };
};
